import { LoadingOutlined } from '@ant-design/icons';
import { Space } from 'antd';

export interface LoadingPropsType {
  text?: string;
  style?: React.CSSProperties;
}
const Loading = ({ text, style }: LoadingPropsType) => {
  return (
    <div
      style={{
        height: 200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      <Space>
        <span>{text}</span>
        <LoadingOutlined />
      </Space>
    </div>
  );
};
export default Loading;
